// eslint-disable-next-line no-shadow
enum ECalendarDisplayMode {
    Normal = 'Normal',
    FullDay = 'FullDay',
}

export default ECalendarDisplayMode
